import { useState, useRef, useEffect } from 'react';

/**
 * Custom hook for managing countdown timer system
 * Handles timer state, countdown logic, and timer cleanup
 */
const useGameTimer = () => {
  const [timerActive, setTimerActive] = useState(false);
  const [timerType, setTimerType] = useState(null); // 'last_player' or 'escalation'
  const [timerDuration, setTimerDuration] = useState(0);
  const [timerRemaining, setTimerRemaining] = useState(0);
  const [timerMessage, setTimerMessage] = useState('');
  const [timerTargetPlayer, setTimerTargetPlayer] = useState(null);
  const timerIntervalRef = useRef(null);

  // Cleanup timer interval on unmount
  useEffect(() => {
    return () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
    };
  }, []);

  return {
    timerActive,
    timerType,
    timerDuration,
    timerRemaining,
    timerMessage,
    timerTargetPlayer,
    setTimerActive,
    setTimerType,
    setTimerDuration,
    setTimerRemaining,
    setTimerMessage,
    setTimerTargetPlayer,
    timerIntervalRef,
  };
};

export default useGameTimer;
